import { render, staticRenderFns } from "./legende-deco.vue?vue&type=template&id=72ac6148&"
import script from "./legende-deco.vue?vue&type=script&lang=js&"
export * from "./legende-deco.vue?vue&type=script&lang=js&"
import style0 from "./legende-deco.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports